import styled, { css } from 'styled-components';

export default styled.div`
  border-radius: 4px;
  background-color: ${({ theme, styling }) =>
    theme.colors[styling].shades['96']};
  color: ${({ theme, styling }) => theme.colors[styling].color};
  margin-top: 5px;
  margin-bottom: 5px;
  position: relative;
  overflow: hidden;

  ${({ accent }) =>
    accent &&
    css`
      &::before {
        content: '';
        background: ${({ theme, styling }) => theme.colors[styling].color};
        position: absolute;
        width: 6.1px;
        height: 100%;
        left: 0;
        top: 0;
      }
    `}
`;
